<template>
  <Modal
    :show="show"
    @close="close"
  >
    <template slot="modal-title">
      <div class="modal-title">
        Galerinizden Ürün Görseli Seçiniz
      </div>
    </template>
    <template slot="modal-body">
      <div class="input-group search left">
        <input
          type="text"
          class="form-control"
          placeholder="Dosya Adı Ara"
          v-model="params.imageName"
          @input="onInput"
        >
        <span class="add-on">
          <img :src="`${$root.cdnUrl}assets/icon-search.png`">
        </span>
      </div>
      <ul class="gallery-items">
        <template v-for="(file, k) in getImages">
          <GalleryItem
            :key="k"
            :file="file"
            @onChecked="onChecked"
          />
        </template>
      </ul>
      <div class="pagination-container">
        <Pagination
          @page="setPage"
          :pagination="getPagination"
        />
      </div>
      <div class="button-container">
        <button
          class="btn btn-trendyol"
          @click="onSelect"
          type="button"
          :disabled="!files.length"
        >
          SEÇİLİ GÖRSELLERİ EKLE
        </button>
      </div>
    </template>
  </Modal>
</template>
<script>
import GalleryItem from './GalleryItem';
import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal';
import Pagination from '@/components/Pagination';

export default {
  name: 'ModalMediaGallery',
  components: {
    Modal,
    GalleryItem,
    Pagination,
  },
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      params: {
        page: 0,
        size: 10,
      },
      files: [],
      selectedFiles: {},
    };
  },
  computed: {
    ...mapGetters({
      getFiles: 'mediaCenter/getFiles',
      getPagination: 'mediaCenter/getPagination',
      getParams: 'mediaCenter/getParams',
      getFormData: 'singleProduct/getFormData',
    }),
    getImages () {
      return this.getFiles.map(item => {
        item.isChecked = this.selectedFiles[item.id];
        return item;
      });
    },
  },
  methods: {
    ...mapActions({
      getAllFiles: 'mediaCenter/getAllFiles',
      setParams: 'mediaCenter/setParams',
    }),
    close () {
      this.$emit('close');
    },
    async setPage (page) {
      this.setParams({
        page,
      });
      await this.getMediaCenter();
    },
    async getMediaCenter () {
      await this.getAllFiles();
    },
    onChecked (file) {
      if (file.isChecked) {
        this.files.push(file);
        this.selectedFiles[file.id] = true;
      } else {
        this.files = this.files.filter(item => item.id !== file.id);
        delete this.selectedFiles[file.id];
      }
    },
    onSelect () {
      this.$emit('onSelect', this.files);
      this.close();
    },
    onInput () {
      this.setParams({
        page: 0,
        imageName: this.params.imageName,
      });
      setTimeout(this.getMediaCenter, 500);
    },
  },
  watch: {
    show () {
      if (this.show) {
        this.setParams(this.params);
        this.files = [];

        this.getMediaCenter();
        this.selectedFiles = [...this.getFormData.productImages].reduce((arr, item) => {
          arr[item.id] = item.isChecked;
          return arr;
        }, {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .gallery-items {
    margin: 0 -15px;
    margin-bottom: 10px;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    max-height: 400px;
    overflow: hidden;
    overflow-y: auto;
  }
  .pagination-container {
    display: flex;
    & > div {
      width: 100%;
    }
    ::v-deep .pagination {
      width: 100%;
      padding: 10px 0;
    }
  }
  .button-container{
    .btn{
      width: 100%;
    }
  }
</style>
